/* @jsxImportSource react */

export const SearchFieldLoading = () => (
  <div className="bg-color-grey-light h-[44px] animate-pulse rounded-[4px]" />
);
